import { createFileRoute } from '@tanstack/react-router';
import { useFeatures } from '@/hooks/useFeatures';
import { usePermissions } from '@/hooks/usePermissions';
import { FiberOutgoingTable } from '../../../-components/FiberOutgoingTable';
import { useFiberOutgoingList } from '../../../-hooks/useFiberOutgoingList';

export const Route = createFileRoute(
  '/(client)/transactions/(pages)/(list)/outgoing/',
)({
  component: OutgoingTransactionsPage,
});

function OutgoingTransactionsPage() {
  const listState = useFiberOutgoingList();
  const { isFeatureEnabled } = useFeatures();
  // Unlike incoming there is no facility setting to consult: any company may
  // despatch. The grant is the whole gate on the write side.
  const canCreateOutgoing = usePermissions()['fiber-forward'].canCreate;
  const canImportOutgoing =
    canCreateOutgoing && isFeatureEnabled('outgoing-transaction-upload');

  return (
    <FiberOutgoingTable
      listState={listState}
      canCreateOutgoing={canCreateOutgoing}
      canImportOutgoing={canImportOutgoing}
    />
  );
}
